module.exports = __webpack_public_path__ + "img/screwdriver-and-wrench.7a5eecd.svg";